import { Link } from "react-router-dom";
import { MEGA_GROUPS } from "./navConfig";
import { SmartLink } from "./NavPrimitives";

const linkCls = "flex items-center gap-2.5 py-1.5 text-sm text-slate-700 hover:text-slate-900";

/** Categorized service list for one group (survey / cad). */
function MobileGroupList({ group, hrefFn, prefix, showTitle }) {
  const GroupIcon = group.icon;
  return (
    <div className="mt-2 first:mt-0">
      {showTitle && (
        <div className="flex items-center gap-1.5 pt-2 mono text-[10px] tracking-[0.22em] uppercase text-slate-900">
          <GroupIcon className="h-3.5 w-3.5 text-topo" /> {group.title}
        </div>
      )}
      {group.categories.map((cat) => (
        <div key={cat.title} className="py-1.5">
          <div className="mono text-[10px] tracking-[0.22em] uppercase text-topo">{cat.title}</div>
          <ul className="mt-1">
            {cat.slugs
              .map((slug) => group.services.find((x) => x.slug === slug))
              .filter(Boolean)
              .map((s) => {
                const Icon = group.iconFor(s);
                return (
                  <li key={s.slug}>
                    <Link to={hrefFn(s.slug)} data-testid={`${prefix}-${s.slug}`} className={linkCls}>
                      <Icon className="h-4 w-4 shrink-0 text-slate-400" strokeWidth={1.75} /> {s.name}
                    </Link>
                  </li>
                );
              })}
          </ul>
        </div>
      ))}
    </div>
  );
}

/** Accordion body for a mobile nav section, based on its menu type. */
export default function MobileMenuContent({ item }) {
  const { menu, key } = item;
  if (menu.type === "group") {
    return <MobileGroupList group={menu.group} hrefFn={menu.group.anchor} prefix={`mobile-${menu.group.id}-link`} />;
  }
  if (menu.type === "mega") {
    return (
      <>
        {MEGA_GROUPS.map((g) => (
          <MobileGroupList key={g.id} group={g} hrefFn={g.href} prefix={g.id === "survey" ? "mobile-mega-link" : `mobile-mega-${g.id}-link`} showTitle />
        ))}
        <Link to="/services" data-testid="mobile-mega-view-all" className="block py-2 mt-1 text-sm font-semibold text-topo">
          View all services →
        </Link>
      </>
    );
  }
  return (
    <ul>
      {menu.columns.flatMap((c) => c.items).map((it) => {
        const Icon = it.icon;
        return (
          <li key={it.key}>
            <SmartLink to={it.to} href={it.href} data-testid={`mobile-${key}-item-${it.key}`} className={linkCls}>
              <Icon className="h-4 w-4 shrink-0 text-slate-400" strokeWidth={1.75} /> {it.label}
            </SmartLink>
          </li>
        );
      })}
    </ul>
  );
}
